import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func stringToNumber
 * @param {string} value - The string value to convert.
 * @param {number} fallback - The fallback value of the conversion if value is incorrect type.
 * defaults to null
 * @return {number}
 * @desc Converts string to a number or returns fallback.
 * ```js
 * stringToNumber('41');
 * // returns 41
 *```
 * @memberof module:String
 * @instance
 */
function stringToNumber(value, fallback = null) {
    return checkTypeValidity(['number', 'numericalString'], value)
        ? Number(value)
        : fallback;
}

export { stringToNumber as default };
